import {z} from 'zod'
import {useTranslation} from '@/translations/i18n'
import {Controller, useFormContext} from 'react-hook-form'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {InputText} from '@/components/commons/input-text/InputText'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {schoolTypeMapToLabel} from '../../utils'
import {MedicalReportFieldsSchema} from '../../formSchemas'
import {SchoolSwitchField} from '../school-switch-field/SchoolSwitchField'
import {SchoolSwitchStepsField} from '../school-switch-steps-field/SchoolSwitchStepsField'

const SchoolFieldsSchema = MedicalReportFieldsSchema.pick({
    schoolType: true,
    schoolName: true,
    hasSupportTeacher: true,
    supportTeacherHours: true,
    hasOepa: true,
    oepaHours: true,
    hasCommunicationAssistant: true,
    inclusionLevel: true
})
type SchoolFieldsSchema = z.infer<typeof SchoolFieldsSchema>

export const SchoolFields = () => {
    const {t} = useTranslation()
    const form = useFormContext<SchoolFieldsSchema>()

    return (
        <Flexbox direction="column" gap={4} fullWidth>
            <Flexbox gap={4} fullWidth>
                <Controller
                    control={form.control}
                    name="schoolType"
                    render={({field, fieldState}) => (
                        <InputSelect
                            label={t('medical_records:school_type')}
                            value={field.value}
                            placeholder={t('commons:select')}
                            optionsMap={schoolTypeMapToLabel}
                            errorMessage={fieldState.error?.message}
                            onChange={field.onChange}
                        />
                    )}
                />
                <InputText
                    type="text"
                    label={t('medical_records:school_name')}
                    placeholder={t('medical_records:insert_info')}
                    {...form.register('schoolName')}
                />
            </Flexbox>

            <Grid columns={2} fullWidth gap={4}>
                <GridItem spanColumn={1}>
                    <SchoolSwitchField
                        name="hasSupportTeacher"
                        label={t('medical_records:support_teacher')}
                        relatedFieldName="supportTeacherHours"
                        relatedFieldLabel={t('medical_records:support_teacher_hours')}
                    />
                </GridItem>
            </Grid>

            <Grid columns={2} fullWidth gap={4}>
                <GridItem spanColumn={1}>
                    <SchoolSwitchField
                        name="hasOepa"
                        label={t('medical_records:oepa')}
                        relatedFieldName="oepaHours"
                        relatedFieldLabel={t('medical_records:oepa_hours')}
                    />
                </GridItem>
            </Grid>

            <SchoolSwitchStepsField />
        </Flexbox>
    )
}
